<template>
    <div class="row mt-0">
        <div class="col-9 p-0">
            <b-form-input size="sm" v-model="currentregex" v-on:keyup="getSearchResults()" @focus="onFocus()"  autocomplete="off"  v-on:keydown.enter.prevent>{{regextext}}</b-form-input>
            <b-form-text  v-text="regexresult" :class="{ noresult : regexresult == 'Geen resultaat gevonden!' }"/>
        </div>
        <div class="col-2 pl-3">
            <div class="row mt-0">
                <b-form-input v-if="!isForFablet && showRegexFieldEditbox" size="sm" v-model="textToFindRegex" autocomplete="off" v-on:keydown.enter.prevent v-on:keyup="findRegexes()"></b-form-input>          
                    <div v-bind:key="regex" v-for="regex in foundArrayOfRegexes" >                  
                        <div v-bind:key="index" v-for="(regexValue, index) in arrayOfFoundRegexValues[regex]" class="col-sm-1 col-form-label col-form-label-sm regexlabel">
                            <a href="javascript:void(0)" v-on:click="setRegexValue(regex)" id="regexValue">{{ regexValue }}</a>
                        </div>
                    </div>
                <b-form-select v-if="dropdown && options != null && options.length > 0" size="sm" v-model="currentregex" :options="options"  v-on:change="getSearchResults()" />
            </div>
        </div>        
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import $ from "jquery"

    export default {
        name: 'MatchRegex',
        props: [ 'currentId', 'regex','dropdown','options','testcontent','isForFablet', 'tryMatchFirstOption', 'showRegexField', 'regexFieldType' ],
        watch: {
            tryMatchFirstOption(newValue) {
                if(this.testcontent == undefined || this.testcontent == null || this.testcontent === "")
                {
                    return;
                } 

                if (newValue && this.options != undefined && this.options.length > 0 && this.regex === '')
                {
                    var payload = {
                        resource: "regex/match",
                        params: {"content": this.testcontent, "regex" : this.options[0]}
                    };
                    
                    this.executeCommand(payload)
                    .then((response) => {
                        if (response === "Geen resultaat gevonden!") {
                            this.currentregex = ''
                            return
                        }
                        
                        this.currentregex = this.options[0]
                        this.currentresult = response;
                        this.$emit('resultRegex', {
                            regexResult: this.currentresult, 
                            regexApplied: this.currentregex
                        }); 
                    })
                    .catch(() => {
                    });
                }   
            }
        },        
        data() {
            return {             
                currentregex: this.regex,
                currentresult: '',
                textToFindRegex: '',
                arrayOfFoundRegexes: [],
                arrayOfFoundRegexValues: [],
                showRegexFieldEditbox: this.showRegexField == undefined ? true : this.showRegexField
            }
        },
        computed: {
            regextext() {
                return this.currentregex
            },
            regexresult() {
                return this.currentresult
            },
            findRegexesText() {
                return this.textToFindRegex
            },
            foundArrayOfRegexes() {
                return this.arrayOfFoundRegexes
            },
            foundArrayOfRegexValues() {
                return this.arrayOfFoundRegexValues
            }
        },
        methods:{
            ...mapActions('fmmodule',['executeCommand']),
            getSearchResults()
            {                                    
                if(this.testcontent == undefined || this.testcontent == null || this.testcontent === "")
                {
                    this.currentresult = 'Er ontbreekt content'
                    return;
                }        

                if (this.currentregex == undefined || this.currentregex == null || this.currentregex === "")
                {
                    this.currentresult = 'Er ontbreekt regex'
                    this.$emit('onChange', this.currentregex);
                    return
                }                
      
                var vm = this;
                var invalidFablets = ["||)", ";()", "+()","+(","\\",";"];
                var isInvalidFablet = invalidFablets.some(el => this.currentregex.endsWith(el)); 

                if(isInvalidFablet)
                {
                    this.currentresult = 'Incorrecte regex'
                }
                else
                {
                    var payload = {
                        resource: this.isForFablet ? "regex/fablet" : "regex/match",
                        params: {"content": this.testcontent, "regex" : this.currentregex}
                    };
                    
                    vm.executeCommand(payload)
                    .then((response) => {
                        this.currentresult = response;
                        this.$emit('resultRegex', {
                            regexResult: this.currentresult, 
                            regexApplied: this.currentregex
                        }); 

                    }).catch(() => {
                        this.currentresult = "";
                    });
                }

                this.$emit('changeIt', isInvalidFablet);
                this.$emit('onChange', this.currentregex);   
            },
            findRegexes()
            {                                    
                var vm = this;
                vm.arrayOfFoundRegexes = []
                vm.arrayOfFoundRegexValues = []

                if(this.testcontent == undefined || this.testcontent == null || this.testcontent === "")
                {
                    return;
                }        

                if (this.textToFindRegex == undefined || this.textToFindRegex == null || this.textToFindRegex === "")
                {
                    return
                }                
      
                var payload = {
                    resource: "regex/findregex/" + (this.regexFieldType == undefined ? "money" : this.regexFieldType),
                    params: {"content": this.testcontent, "text" : this.textToFindRegex}
                };
                
                vm.executeCommand(payload)
                .then((response) => {

                    $.each(response, function (regex, values)
                    {
                        vm.arrayOfFoundRegexes.push(regex);
                        vm.arrayOfFoundRegexValues[regex] = values
                    });
                }).catch(() => {
                    this.arrayOfFoundRegexes = new Array();
                    this.arrayOfFoundRegexValues = new Array()
                });
            },
            setRegexValue(regex)
            {
                this.currentregex = regex
                this.getSearchResults()
            },        
            onFocus()
            {                         
                if(this.testcontent == undefined || this.testcontent == null || this.testcontent === "")
                {
                    return;
                }

                if (this.currentregex == undefined || this.currentregex == null || this.currentregex === "")
                {
                    return
                }                

                this.$emit('resultRegex', {
                    regexResult: this.currentresult, 
                    regexApplied: this.currentregex
                }); 
                this.$emit('onChange', this.currentregex); 
            }
        },
        created() {
            var vm = this
            vm.currentregex = this.regex  

            this.getSearchResults()
        }
    }
</script>
<style>
.noresult{
    color: #ff4b4b !important;
}

.regexlabel {
    display: block;
    margin-left: -15px;
    margin-right: 1000px;
    color: #7abd59;

}

a:link { 
    COLOR: #7abd59; font-weight: normal 
}
a:visited { 
    COLOR: #7abd59; font-weight: normal 
}
a:active { 
    COLOR: blue; font-weight: bold 
}
a:hover { 
    COLOR: blue; font-weight: bold 
}
</style>